/** Fases mínimas do cliente no wizard essencial (linguagem do time, não teoria). */
export const DEFAULT_SETUP_AWARENESS_LEVELS = [
  { title: "Ainda não viu o problema", description: "Não percebeu que precisa resolver algo." },
  { title: "Sabe que precisa resolver", description: "Reconhece a necessidade, ainda sem solução." },
  { title: "Está comparando opções", description: "Olha alternativas, inclusive a de vocês." },
  { title: "Já conhece vocês", description: "Sabe quem vocês são; ainda não fechou." },
  { title: "Pronto para fechar", description: "Pode comprar ou já é cliente." },
];
